import { addAndTrack } from "../../../calculators/helpers";
import { findByCode } from "../../../helpers";
import { Green } from "../../../styledCpns/DataDisplay";
import { GrayStats, GreenStats, wpSimpleAnTmaker } from "../config";
import { BaneSeries1, CullTheWeak } from "../series";

const OtherBows = [
  {
    code: 127,
    name: "Recurve Bow",
    icon: "b/b5/Weapon_Recurve_Bow",
    rarity: 3,
    mainStatScale: 38,
    subStat: { type: "HP%", scale: "10.2%" },
    ...CullTheWeak
  },
  {
    code: 1,
    name: "Messenger",
    icon: "3/38/Weapon_Messenger",
    rarity: 3,
    mainStatScale: 40,
    subStat: { type: "CRIT DMG", scale: "6.8%" },
    pasvName: "Archer's Message",
    pasvDescs: ({ wpRfm }) => [
      {
        bonus: (
          <>
            Charged Attack hits on weak spots deal an additional{" "}
            <Green b>{75 + wpRfm * 25}%</Green> <Green>ATK</Green> DMG as CRIT
            DMG. Can only occur once every 10s.
          </>
        )
      }
    ]
  },
  {
    code: 2,
    name: "Raven Bow",
    icon: "d/d0/Weapon_Raven_Bow",
    rarity: 3,
    mainStatScale: 40,
    subStat: { type: "Elemental Mastery", scale: 20 },
    ...BaneSeries1("Flame and Water", "Hydro or Pyro")
  },
  {
    code: 3,
    name: "Sharpshooter's Oath",
    icon: "5/52/Weapon_Sharpshooter%27s_Oath",
    rarity: 3,
    mainStatScale: 39,
    subStat: { type: "CRIT DMG", scale: "10.2%" },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: wpSimpleAnTmaker("hitBnes", "CA.pct", 6),
        desc: ({ wpRfm }) =>
          findByCode(OtherBows, 3).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Precise",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            Increases <Green>DMG</Green> against weak spots by{" "}
            <Green b>{18 + wpRfm * 6}%</Green>.
          </>
        )
      }
    ]
  },
  {
    code: 4,
    name: "Slingshot",
    icon: "c/ca/Weapon_Slingshot",
    rarity: 3,
    mainStatScale: 38,
    subStat: { type: "CRIT Rate", scale: "6.8%" },
    addBnes: ({ hitBnes, tkDesc, tracker }) => {
      if (hitBnes) {
        addAndTrack(tkDesc, hitBnes, ["NA.pct", "CA.pct"], -10, tracker);
      }
    },
    buffs: [
      {
        index: 0,
        affect: "self",
        addBnes: ({ hitBnes, wpRfm, tkDesc, tracker }) => {
          const bnValue = 40 + wpRfm * 6;
          addAndTrack(tkDesc, hitBnes, ["NA.pct", "CA.pct"], bnValue, tracker);
        },
        desc: ({ wpRfm }) =>
          findByCode(OtherBows, 4).pasvDescs({ wpRfm })[0].buff
      }
    ],
    pasvName: "Slingshot",
    pasvDescs: ({ wpRfm }) => [
      {
        buff: (
          <>
            If a <Green>Normal or Charged Attack</Green> hits a target within
            0.3s of being fired, increases <Green>DMG</Green> by{" "}
            <Green b>{30 + wpRfm * 6}%</Green>. Otherwise, decreases DMG by 10%.
          </>
        )
      }
    ]
  },
  {
    code: 10,
    name: "Seasoned Hunter's Bow",
    icon: "8/82/Weapon_Seasoned_Hunter%27s_Bow",
    ...GreenStats
  },
  {
    code: 11,
    name: "Hunter's Bow",
    icon: "4/44/Weapon_Hunter%27s_Bow",
    ...GrayStats
  }
];

export default OtherBows;
